import { ApiClient } from "./api-client";

export function getUsers(queryParams, systemAccount = true) {
  return ApiClient.getInstance().get('/user', {
    params: { ...queryParams, systemAccount }
  }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}


export function getSystemUser(userId, queryParams) {
  return ApiClient.getInstance().get('/user/:id', { urlParams: { id: userId }, params: queryParams }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function createSystemUser(name, identifier, password, role) {
  return ApiClient.getInstance().post('/user/system', { firstname: name, email: identifier, password: password, roleId: role }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function updateSystemUser(userId, name, identifier, password, role) {
  const payload = {
    id: userId,
    firstname: name,
    email: identifier,
    roleId: role
  };
  if (password !== undefined) {
    payload.password = password;
  }
  return ApiClient.getInstance()
    .put('/user/system', payload)
    .catch((error) => {
      console.error('Error updating user data:', error);
      throw error;
    });
}
  
export function logoutSystem(password) {
  return ApiClient.getInstance()
    .post('/user/system/logout', { password: password })
    .then((response) => {
      localStorage.removeItem('selectedRoomId');
      localStorage.removeItem('hoursShownOnDisplay');
      return response;
    })
    .catch((error) => {
      console.error('Error during logout:', error);
      throw error;
    });
}
  